import { Button } from '@component/Button';
import { loadList } from './queries/list';

export const ExportCSV = ({ db, databaseKey, fileName }) => {
  const downloadCSV = async () => {
    const data = await loadList(db, databaseKey);
    const csvString = [
      [
        'HAM Code',
        'Product Name',
        'Product Description',
        'Product Description 1',
        'Product Description 2',
        'Has 3D Model',
        'Has 2D Image',
      ],
      ...data.map(item => [
        escapeCSV(item.meatcutCode),
        escapeCSV(item.meatcutName),
        escapeCSV(item.meatcutDetail),
        escapeCSV(item.meatcutDetail1),
        escapeCSV(item.meatcutDetail2),
        item.modelUrl ? 'Y' : 'N',
        item.carcaseUrl ? 'Y' : 'N',
      ]),
    ]
      .map(row => row.join(','))
      .join('\n');

    const blob = new Blob([csvString], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'download.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return <Button onClick={downloadCSV}>Export CSV</Button>;
};

const escapeCSV = value => {
  if (value == null) return '';

  const str = String(value);

  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }

  return str;
};

export default ExportCSV;
